import { isScheme, schemeTypeLine } from "@/lib/schemes";

const SIZE_FOR = { plane: "planechase", phenomenon: "planechase", scheme: "scheme", ongoing_scheme: "scheme", vanguard: "vanguard" };
const KINDS = [
  ["game", "Magic card (creature, spell, land, planeswalker…)"],
  ["scheme:standard", "Scheme"],
  ["ongoing_scheme:standard", "Ongoing Scheme"],
  ["scheme:eminent", "Eminent Scheme (homebrew)"],
  ["scheme:secret", "Secret Scheme (homebrew)"],
  ["scheme:grand", "Grand Scheme (homebrew)"],
  ["scheme:legendary_schemer", "Legendary Schemer: planeswalker scheme with loyalty (homebrew)"],
  ["plane", "Plane"], ["phenomenon", "Phenomenon"], ["vanguard", "Vanguard"],
];
const AUTO_LINES = new Set(["", "Plane", "Phenomenon", "Vanguard", ...["scheme", "ongoing_scheme"].flatMap((k) => ["standard", "eminent", "secret", "legendary_schemer", "grand"].map((s) => schemeTypeLine(k, s)))]);

export const kindOf = (f) => {
  if (f.category !== "specialty") return f.category && f.category !== "game_card" ? "other" : "game";
  if (isScheme(f.specialty_type)) return `${f.specialty_type}:${f.scheme.scheme_subtype || "standard"}`;
  return SIZE_FOR[f.specialty_type] ? f.specialty_type : "other";
};

const patchFor = (value, f) => {
  if (value === "game") {
    const wasSchemer = kindOf(f).endsWith("legendary_schemer");
    return { category: "", specialty_type: "", preset: Object.values(SIZE_FOR).includes(f.preset) ? "standard" : f.preset,
      faces: f.faces.map((fc, i) => (i === 0 ? { ...fc, type_line: AUTO_LINES.has(fc.type_line || "") ? "" : fc.type_line, loyalty: wasSchemer ? "" : fc.loyalty } : fc)) };
  }
  const [sp, sub = "standard"] = value.split(":");
  const line = isScheme(sp) ? schemeTypeLine(sp, sub) : sp[0].toUpperCase() + sp.slice(1);
  const tl = f.faces[0].type_line || "";
  return { category: "specialty", specialty_type: sp, preset: SIZE_FOR[sp], scheme: { ...f.scheme, scheme_subtype: isScheme(sp) ? sub : "standard" },
    faces: f.faces.map((fc, i) => (i === 0 && AUTO_LINES.has(tl) ? { ...fc, type_line: line } : fc)) };
};

export function CardKindPicker({ form, onChange }) {
  const value = kindOf(form);
  return (
    <div>
      <label className="field-label" htmlFor="card-kind">What are you making?</label>
      <select id="card-kind" className="field" value={value} onChange={(e) => onChange(patchFor(e.target.value, form))} data-testid="editor-card-kind-select">
        {KINDS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
        {value === "other" && <option value="other" disabled>Other (set in Advanced)</option>}
        {value !== "other" && !KINDS.some(([v]) => v === value) && <option value={value}>{schemeTypeLine(...value.split(":"))} (homebrew)</option>}
      </select>
    </div>
  );
}
